import React from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import Sidebar from "../common/sidebar";
import { useTranslation } from "react-i18next";

const Unauthorized = () => {
 const { t } = useTranslation();

  return (
    <section className="dashboard-block">
      <Sidebar />
      <div className="dash-left">
        <Header />
        <section className="cart-block">
          <div className="container">
            <div className="unauthorized-wrap">
              <p>
                <i className="fa fa-exclamation-triangle"></i> {t("access_denied_txt")}
              </p>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </section>
  );
};

export default Unauthorized;
